import script from "./ComputeTasksNested.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeTasksNested.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeTasksNested.vue?vue&type=style&index=0&id=cb982164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb982164"]])

export default __exports__